import React, { useState, useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { useLoginModal } from "../../contexts/LoginModalContext";
import Logo from "../../assets/img/logorote.png";

const Header = () => {
  const history = useHistory();
  const location = useLocation();
  const { openModal } = useLoginModal();
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isVerySmall, setIsVerySmall] = useState(window.innerWidth < 400);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
      setIsVerySmall(window.innerWidth < 400);
      if (window.innerWidth >= 768) {
        setIsMenuOpen(false);
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const headerStyle = {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: isMobile ? "12px 15px" : "15px 40px",
    backgroundColor: "#ffffff",
    boxShadow: "0 2px 10px rgba(0,0,0,0.05)",
    position: "sticky",
    top: 0,
    zIndex: 1000,
    flexWrap: "wrap",
  };

  const logoStyle = {
    fontWeight: "600",
    color: "#e63946",
    fontSize: isMobile ? "16px" : "22px",
    display: "flex",
    alignItems: "center",
    flex: isMobile ? "1" : "none",
  };

  const logoTextStyle = {
    marginLeft: isMobile ? "8px" : "12px",
    letterSpacing: "-0.5px",
    display: isMobile && isVerySmall ? "none" : "inline",
  };

  const navStyle = {
    listStyle: "none",
    display: isMobile && !isMenuOpen ? "none" : "flex",
    flexDirection: isMobile ? "column" : "row",
    margin: 0,
    padding: isMobile ? "20px 0" : 0,
    gap: isMobile ? "15px" : "30px",
    alignItems: isMobile ? "flex-start" : "center",
    width: isMobile ? "100%" : "auto",
    order: isMobile ? 3 : 0,
    borderTop: isMobile && isMenuOpen ? "1px solid #f1f3f5" : "none",
    marginTop: isMobile && isMenuOpen ? "15px" : 0,
  };

  const navItemStyle = {
    color: "#2d3436",
    textDecoration: "none",
    fontSize: "15px",
    cursor: "pointer",
    fontWeight: "400",
    transition: "color 0.3s ease",
    padding: "8px 0",
  };

  const buttonStyle = {
    backgroundColor: "#e63946",
    color: "white",
    border: "none",
    borderRadius: "25px",
    padding: "10px 25px",
    cursor: "pointer",
    outline: "none",
    fontSize: "14px",
    fontWeight: "500",
    transition: "all 0.3s ease",
    marginLeft: "15px",
  };

  const buttonSecondaryStyle = {
    backgroundColor: "transparent",
    color: "#e63946",
    border: "2px solid #e63946",
    borderRadius: "25px",
    padding: isMobile ? "6px 15px" : "8px 23px",
    cursor: "pointer",
    outline: "none",
    fontSize: isMobile ? "12px" : "14px",
    fontWeight: "500",
    transition: "all 0.3s ease",
  };

  const hamburgerStyle = {
    display: isMobile ? "flex" : "none",
    flexDirection: "column",
    cursor: "pointer",
    padding: "5px",
    gap: "4px",
  };

  return (
    <header style={headerStyle}>
      <div
        style={logoStyle}
        onClick={() => history.push("/login")}
        onMouseEnter={(e) => {
          e.currentTarget.style.cursor = "pointer";
        }}
      >
        <img src={Logo} style={{ width: isMobile ? 35 : 45 }} alt="Logo" />
        <span style={logoTextStyle}>Aplikasi Donor Darah</span>
      </div>

      {isMobile && (
        <div style={hamburgerStyle} onClick={() => setIsMenuOpen(!isMenuOpen)}>
          <div
            style={{
              width: "25px",
              height: "3px",
              background: "#2d3436",
              borderRadius: "2px",
              transition: "all 0.3s ease",
              transform: isMenuOpen
                ? "rotate(45deg) translate(5px, 5px)"
                : "none",
            }}
          />
          <div
            style={{
              width: "25px",
              height: "3px",
              background: "#2d3436",
              borderRadius: "2px",
              transition: "all 0.3s ease",
              opacity: isMenuOpen ? 0 : 1,
            }}
          />
          <div
            style={{
              width: "25px",
              height: "3px",
              background: "#2d3436",
              borderRadius: "2px",
              transition: "all 0.3s ease",
              transform: isMenuOpen
                ? "rotate(-45deg) translate(7px, -6px)"
                : "none",
            }}
          />
        </div>
      )}

      <nav style={{ width: isMobile ? "100%" : "auto" }}>
        <ul style={navStyle}>
          <li
            style={{
              ...navItemStyle,
              color: location.pathname === "/login" ? "#e63946" : "#2d3436",
            }}
            onClick={() => history.push("/login")}
            onMouseEnter={(e) => (e.target.style.color = "#e63946")}
            onMouseLeave={(e) =>
              (e.target.style.color =
                location.pathname === "/login" ? "#e63946" : "#2d3436")
            }
          >
            Beranda
          </li>
          <li
            style={{
              ...navItemStyle,
              color:
                location.pathname === "/stok-darah" ? "#e63946" : "#2d3436",
            }}
            onClick={() => history.push("/stok-darah")}
            onMouseEnter={(e) => (e.target.style.color = "#e63946")}
            onMouseLeave={(e) =>
              (e.target.style.color =
                location.pathname === "/stok-darah" ? "#e63946" : "#2d3436")
            }
          >
            Stok Darah
          </li>
          <li
            style={{
              ...navItemStyle,
              color:
                location.pathname === "/permintaan-donor-publik"
                  ? "#e63946"
                  : "#2d3436",
            }}
            onClick={() => history.push("/permintaan-donor-publik")}
            onMouseEnter={(e) => (e.target.style.color = "#e63946")}
            onMouseLeave={(e) =>
              (e.target.style.color =
                location.pathname === "/permintaan-donor-publik"
                  ? "#e63946"
                  : "#2d3436")
            }
          >
            Permintaan Donor Darah
          </li>
          <li
            style={{
              ...navItemStyle,
              color:
                location.pathname === "/registrasi-pendonor"
                  ? "#e63946"
                  : "#2d3436",
            }}
            onClick={() => history.push("/registrasi-pendonor")}
            onMouseEnter={(e) => (e.target.style.color = "#e63946")}
            onMouseLeave={(e) =>
              (e.target.style.color =
                location.pathname === "/registrasi-pendonor"
                  ? "#e63946"
                  : "#2d3436")
            }
          >
            Registrasi Calon Pendonor
          </li>
        </ul>
      </nav>
      {!isMobile && (
        <div style={{ display: "flex", alignItems: "center" }}>
          <button
            style={buttonSecondaryStyle}
            onClick={openModal}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = "#e63946";
              e.currentTarget.style.color = "#ffffff";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = "transparent";
              e.currentTarget.style.color = "#e63946";
            }}
          >
            Masuk
          </button>
        </div>
      )}
      {isMobile && isMenuOpen && (
        <div
          style={{
            width: "100%",
            order: 4,
            marginTop: "15px",
            paddingTop: "15px",
            borderTop: "1px solid #f1f3f5",
          }}
        >
          <button
            style={{
              ...buttonSecondaryStyle,
              width: "100%",
              padding: "10px",
            }}
            onClick={() => {
              openModal();
              setIsMenuOpen(false);
            }}
          >
            Masuk
          </button>
        </div>
      )}
    </header>
  );
};

export default Header;
